const $ = jQuery;
const growDuration = 500;

const animateDock = (dock, el) => {
  if ($(`#${dock}`).hasClass('og-animated')) {
    return;
  }

  $(`#${dock}`).addClass('og-animated');

  const dockId = dock.slice(dock.length - 1);

  el.select(`#${dock}`)
    .animate(250 * dockId, '>', 15 * (dockId - 1))
    .transform({
      scaleX: 1,
      cx: 0,
      cy: 0,
    })
    .after(function () {
      const thisId = this.attr('id');
      const shipId = thisId.replace('_item_', '_ship_');
      const waveId = thisId.replace('_item_', '_wave_');
      const liftId = thisId.replace('_item_', '_lift_');
      el.select(`#${waveId}`).animate(100).opacity(1); // Set opacity of wave to 1 after dock scales in
      el.select(`#${waveId}`).animate(growDuration).transform({ x: 0 }); // Move wave after dock scales in
      el.select(`#${shipId}`).animate(300).opacity(1); // Set opacity of dock ship to 1 after dock scales in
      el.select(`#${shipId}`).animate(growDuration).transform({ x: 0 }); // Move dock ship after dock scales in

      if ($('#dock_crane_front').length) {
        // Front crane
        el.select('#dock_crane_front')
          .delay(1000)
          .animate(200)
          .opacity(1)
          .animate(2800, '<>')
          .transform({ x: 105 })
          .delay(200)
          .animate(2800, '<>')
          .transform({ x: 0 });
        // Back crane
        el.select('#dock_crane_back')
          .delay(1000)
          .animate(200)
          .opacity(1)
          .animate(2800, '<>')
          .transform({ x: -85 })
          .delay(200)
          .animate(2800, '<>')
          .transform({ x: 0 });
      }

      if ($('#dock_ship_clone').length) {
        el.select('#dock_ship_clone').delay(1000).animate(200).opacity(1);
      }

      if ($(`#${liftId}`).length) {
        el.select('#ship_lift_leg_1').animate(100).opacity(1);
        el.select('#ship_lift_leg_2').animate(100).opacity(1);
        el.select('#ship_lift_leg_3').animate(100).opacity(1);
        el.select('#ship_lift_leg_4').animate(100).opacity(1);
        el.select(`#${liftId}`)
          .animate(150)
          .opacity(1)
          .animate(2000)
          .transform({ y: -5 })
          .delay(2000)
          .animate(2000)
          .transform({ y: 10 });
      }
    });
};

export default animateDock;
